import type { BatchContext } from '../../utils/createBatchQueue';
import { createBatchQueue } from '../../utils/createBatchQueue';
import { sharedCartState } from './sharedCartState';

// Cart-specific context interface
interface CartBatchContext extends BatchContext {
	shippingAddressId?: number;
	billingAddressId?: number;
}

// Create cart-specific batch queue instance.
// suppressErrorToast: useCartOperations renders a tailored toast via the
// rejected promise — without this, the user sees two toasts on every failure.
export const batchCartQueue = createBatchQueue<CartBatchContext>({
	entityName: 'cart',
	batchDelay: 300,
	apiEndpoint: (clientId) => `/orders/cart/${clientId}/batch`,
	suppressErrorToast: true,
	processResponse: (result, clientId) => {
		// Update shared cart state with the batch response
		if (result.data != null) {
			const cartResponse = result.data.data ?? result.data;

			if (cartResponse?.orderDetails != null) {
				const serverCartData: Record<
					number,
					{ quantity: number; price: number }
				> = {};

				cartResponse.orderDetails.forEach(
					(detail: {
						_fk_item__id?: number;
						deletedDate?: string | null;
						quantityOrdered?: number;
						price?: number;
					}) => {
						if (
							detail._fk_item__id != null &&
							(detail.deletedDate == null || detail.deletedDate === null)
						) {
							serverCartData[detail._fk_item__id] = {
								quantity: detail.quantityOrdered ?? 0,
								price: detail.price ?? 0,
							};
						}
					},
				);

				// Update shared state with server data
				sharedCartState.updateCartItems(clientId.toString(), serverCartData);
			}
		}
	},
	handleError: (error, clientId, operations) => {
		console.error(
			`[BatchCartQueue] Batch failed for client ${clientId}:`,
			error,
		);
		console.error(`[BatchCartQueue] Failed operations:`, operations);
	},
});
